import React from "react";

const ConfirmationModal = ({
  isVisible,
  title = "Confirm Action",
  message = "Are you sure you want to proceed?",
  onConfirm,
  onCancel,
  confirmLabel = "Yes",
  cancelLabel = "No",
  confirmColor = "bg-red-600",
  cancelColor = "bg-gray-300",
}) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-96 max-w-full">
        <h2 className="text-xl font-semibold">{title}</h2>
        <p className="mt-2 text-gray-700">{message}</p>
        <div className="flex justify-end mt-4">
          <button
            className={`px-4 py-2 rounded-lg mr-2 ${cancelColor}`}
            onClick={onCancel}
          >
            {cancelLabel}
          </button>
          <button
            className={`px-4 py-2 rounded-lg text-white ${confirmColor}`}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
